import messages from './utils/messages'

const GETTERS = {
  messageViews(state) {
    const { views } = state
    return views
  },
  currentMessage(state, getters, rootState, rootGetters) {
    const currentComponentName = rootGetters['tools/currentComponentName']
    const { messageViews } = getters
    const foundMessages = !!currentComponentName && messageViews[currentComponentName]

    return Array.isArray(foundMessages) && foundMessages[foundMessages.length - 1]
  },
  isCurrentMessageActive(state, getters) {
    return getters.currentMessage?.isActive
  },
  statusCodes(state, getters, rootState, rootGetters) {
    const { statusCodes } = messages
    const isCustomAnalyticUser = rootGetters['auth/isCustomAnalyticUser']
    const customAnalytics = rootGetters['auth/customAnalytics']

    if (isCustomAnalyticUser) {
      const errorIndex = statusCodes.findIndex((status) => status.code === 400)
      const error400 = statusCodes[errorIndex]
      const newError400 = { ...error400, options: customAnalytics }

      statusCodes.splice(errorIndex, 1, newError400)
    }

    return statusCodes
  },
}

export default GETTERS
